import { LoginComponent } from "./features/auth/login/login.component";
import { UnauthorizedComponent } from "./features/auth/unauthorized/unauthorized.component";
import { AppShellComponent } from "./shared/components/app-shell/app-shell.component";
import { NotFoundComponent } from "./features/not-found/not-found.component";
import { authGuard } from "./core/guards/auth.guard";

import type { Routes } from "@angular/router";

export const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "unauthorized", component: UnauthorizedComponent },
  {
    path: "",
    component: AppShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: "service-providers",
        loadChildren: () =>
          import("./features/service-providers/service-providers.routes").then(
            (m) => m.SERVICE_PROVIDER_ROUTES
          ),
      },
      {
        path: "employees",
        loadChildren: () =>
          import("./features/employees/employees.routes").then(
            (m) => m.EMPLOYEES_ROUTES
          ),
      },
      {
        path: "admin",
        loadChildren: () =>
          import("./features/admin/service-accounts/service-accounts.routes").then(
            (m) => m.ADMIN_ROUTES
          ),
      },
      { path: "", redirectTo: "service-providers", pathMatch: "full" },
    ],
  },
  { path: "**", component: NotFoundComponent },
];
